import { render, staticRenderFns } from "./FulfillmentMerchants.vue?vue&type=template&id=6f475b22"
import script from "./FulfillmentMerchants.vue?vue&type=script&lang=js"
export * from "./FulfillmentMerchants.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentMerchants.vue?vue&type=style&index=0&id=6f475b22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports